module.exports = __webpack_public_path__ + "img/unicef.69c46858.svg";